/**
 * X-All paid lander Variant C (offer_id=mpc-lander-v3, uid=3).
 * Owner: docs/projects/mpc-lander/plan.md, Offer 3.
 * Isolated from Variants A/B. Simple monthly S&S + one-time choice, one optional
 * one-time cloth add-on, then a verified Shopify checkout handoff. A qualifying
 * question ("How often do you clean?") maps to 1 or 2 packs in the buy box; the
 * confirmation drawer's stepper shares the same quantity state and stays in sync.
 */
(function () {
  'use strict';

  var ROOT = document.getElementById('xall-lander');
  if (!ROOT) return;

  var OFFER_ID = 'mpc-lander-v3';
  var OFFER_UID = '3';
  var FREE_SHIP_CODE = 'MPC-LANDER-FREESHIP';
  var TWO_PACK_CODE = 'XALL-2PACK';
  var ATTRIBUTION_KEY = 'xall_lander_refills_attribution';
  var ATTRIBUTION_KEYS = [
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term',
    'gclid', 'fbclid', 'ttclid', 'af_source', 'oid', 'affid',
    'sub1', 'sub2', 'sub3', 'sub4', 'sub5'
  ];

  var dataNode = document.getElementById('xall-lander-data');
  var CONFIG = {};
  try { CONFIG = dataNode ? JSON.parse(dataNode.textContent) : {}; } catch (err) {
    console.warn('[xall-lander-refills] invalid commerce config', err);
  }
  CONFIG.commerce = CONFIG.commerce || {};
  CONFIG.commerce.products = CONFIG.commerce.products || {};
  CONFIG.commerce.plans = CONFIG.commerce.plans || {};
  CONFIG.commerce.bonus = CONFIG.commerce.bonus || {};
  CONFIG.copy = CONFIG.copy || {};
  CONFIG.assets = CONFIG.assets || {};

  var state = {
    mode: 'sub',
    qty: 1,
    cloth: false,
    cartOpen: false,
    demoOpen: false,
    slide: 0,
    buyboxSlide: 0,
    testimonialSlide: 0,
    faqOpen: {}
  };

  var PRICES = {
    sub: { 1: 16.96, 2: 31.92 },
    one: { 1: 19.95, 2: 34.95 },
    retail: { 1: 19.95, 2: 39.90 },
    cloth: 19.95
  };

  var HERO_KEYS = ['reasonGrease', 'reasonSurfaces', 'reasonScent', 'review1After', 'review2After', 'review4After'];
  var BUYBOX_KEYS = ['buybox1', 'buybox2', 'buybox3', 'buybox4', 'buybox5', 'buybox6'];
  var BUYBOX_ALT = [
    'X-ALL Multi-Purpose Cleaner and refill tablets',
    'How to mix and use X-ALL Multi-Purpose Cleaner',
    'X-ALL loosening baked-on grease',
    'Shower corner before and after X-ALL',
    'Oven before and after X-ALL',
    'Bathtub before and after X-ALL'
  ];
  var VIDEO_KEYS = {
    reasonGrease: 'reasonGreaseVideo',
    reasonSurfaces: 'reasonSurfacesVideo',
    buybox3: 'buybox3Video'
  };

  var el = {
    countdown: ROOT.querySelector('[data-xl="countdown"]'),
    announce: ROOT.querySelector('.xl-announce__text'),
    stickyLabel: ROOT.querySelector('.xl-sticky-bar__label'),
    heroImg: ROOT.querySelector('[data-xl="hero-slide-img"]'),
    heroVideo: ROOT.querySelector('[data-xl="hero-slide-video"]'),
    buyboxImg: ROOT.querySelector('[data-xl="buybox-slide-img"]'),
    buyboxVideo: ROOT.querySelector('[data-xl="buybox-slide-video"]'),
    dots: ROOT.querySelectorAll('[data-xl="dot"]'),
    thumbs: ROOT.querySelectorAll('[data-xl="thumb"]'),
    prev: ROOT.querySelector('[data-xl="gallery-prev"]'),
    next: ROOT.querySelector('[data-xl="gallery-next"]'),
    testimonials: ROOT.querySelectorAll('[data-xl-testimonial]'),
    testimonialDots: ROOT.querySelectorAll('[data-xl="testimonial-dot"]'),
    testimonialPrev: ROOT.querySelector('[data-xl="testimonial-prev"]'),
    testimonialNext: ROOT.querySelector('[data-xl="testimonial-next"]'),
    qualTiles: ROOT.querySelectorAll('[data-xlr-qual]'),
    qualSub2: ROOT.querySelector('[data-xlr="qual-sub-2"]'),
    qualNote: ROOT.querySelector('[data-xlr="qual-note"]'),
    qualNoteText: ROOT.querySelector('[data-xlr="qual-note-text"]'),
    modeOptions: ROOT.querySelectorAll('[data-xlr-mode]'),
    choiceCards: ROOT.querySelectorAll('[data-xlr-card]'),
    subBadge: ROOT.querySelector('[data-xlr="sub-badge"]'),
    subCadence: ROOT.querySelector('[data-xlr="sub-cadence"]'),
    subPrice: ROOT.querySelector('[data-xlr="sub-price"]'),
    subWas: ROOT.querySelector('[data-xlr="sub-was"]'),
    subBilledRow: ROOT.querySelector('[data-xlr="sub-billed-row"]'),
    onePrice: ROOT.querySelector('[data-xlr="one-price"]'),
    oneWas: ROOT.querySelector('[data-xlr="one-was"]'),
    billedNote: ROOT.querySelector('[data-xlr="billed-note"]'),
    startCta: ROOT.querySelector('[data-xlr="start-cta"]'),
    trust2: ROOT.querySelector('[data-xlr="trust-2"]'),
    trust3: ROOT.querySelector('[data-xlr="trust-3"]'),
    valueName: ROOT.querySelector('[data-xlr="value-mpc-name"]'),
    valueWas: ROOT.querySelector('[data-xlr="value-mpc-was"]'),
    valuePrice: ROOT.querySelector('[data-xlr="value-mpc-price"]'),
    valueTotal: ROOT.querySelector('[data-xlr="value-total"]'),
    valueFootnote: ROOT.querySelector('[data-xlr="value-footnote"]'),
    faqItems: ROOT.querySelectorAll('[data-xl-faq]'),
    drawerScrim: ROOT.querySelector('[data-xl="drawer-scrim"]'),
    drawer: ROOT.querySelector('.xlr-drawer'),
    drawerClose: ROOT.querySelector('[data-xl="close-cart"]'),
    cartImg: ROOT.querySelector('[data-xl="cart-base-img"]'),
    cartMode: ROOT.querySelector('[data-xlr="cart-mode"]'),
    cartQty: ROOT.querySelector('[data-xlr="cart-qty"]'),
    cartPrice: ROOT.querySelector('[data-xlr="cart-price"]'),
    cartDec: ROOT.querySelector('[data-xlr="cart-dec"]'),
    cartInc: ROOT.querySelector('[data-xlr="cart-inc"]'),
    clothCard: ROOT.querySelector('[data-xlr="cloth-card"]'),
    clothToggle: ROOT.querySelector('[data-xlr="cloth-toggle"]'),
    subtotal: ROOT.querySelector('[data-xl="subtotal"]'),
    shippingNote: ROOT.querySelector('[data-xlr="shipping-note"]'),
    checkout: ROOT.querySelector('[data-xl="checkout"]'),
    checkoutNotice: ROOT.querySelector('[data-xl="checkout-notice"]'),
    modalScrim: ROOT.querySelector('[data-xl="modal-scrim"]'),
    modalClose: ROOT.querySelector('[data-xl="close-demo"]'),
    modalVideo: ROOT.querySelector('[data-xl="modal-video"]'),
    modalTitle: ROOT.querySelector('[data-xl="modal-title"]'),
    modalDesc: ROOT.querySelector('[data-xl="modal-desc"]'),
    wordScrim: ROOT.querySelector('[data-xl="word-modal-scrim"]'),
    wordClose: ROOT.querySelector('[data-xl="close-word-video"]'),
    wordVideo: ROOT.querySelector('[data-xl="word-modal-video"]'),
    lazyVideos: ROOT.querySelectorAll('[data-xl="lazy-video"]')
  };

  var drawerReturnFocus = null;
  var wordReturnFocus = null;
  var wordMarqueePaused = false;
  var checkoutInFlight = false;
  var countdownEnd = Date.now() + (6 * 60 * 60 + 35 * 60 + 7) * 1000;

  function money(value) { return '$' + Number(value).toFixed(2); }
  function asset(key) { return CONFIG.assets[key] || ''; }
  function copyText(key, fallback) { return CONFIG.copy[key] || fallback; }
  function setText(node, value) { if (node) node.textContent = value; }
  function emit(name, detail) {
    var payload = Object.assign({ offer_id: OFFER_ID, uid: OFFER_UID }, detail || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, payload));
    document.dispatchEvent(new CustomEvent('xall:' + name, { detail: payload }));
  }

  function captureAttribution() {
    var saved = {};
    try { saved = JSON.parse(sessionStorage.getItem(ATTRIBUTION_KEY) || '{}'); } catch (err) {}
    var params = new URLSearchParams(window.location.search);
    ATTRIBUTION_KEYS.forEach(function (key) {
      var value = params.get(key);
      if (value) saved[key] = value;
    });
    saved.offer_id = OFFER_ID;
    saved.uid = OFFER_UID;
    try { sessionStorage.setItem(ATTRIBUTION_KEY, JSON.stringify(saved)); } catch (err) {}
    return saved;
  }

  function getAttribution() {
    var value = {};
    try { value = JSON.parse(sessionStorage.getItem(ATTRIBUTION_KEY) || '{}'); } catch (err) {}
    value.offer_id = OFFER_ID;
    value.uid = OFFER_UID;
    return value;
  }

  function current() {
    var total = PRICES[state.mode][state.qty] + (state.cloth ? PRICES.cloth : 0);
    return {
      base: PRICES[state.mode][state.qty],
      retail: PRICES.retail[state.qty],
      total: total,
      savingsPct: state.mode === 'sub' ? (state.qty === 2 ? 20 : 15) : 0,
      refills: state.qty * 5
    };
  }

  function render() {
    var d = current();
    ROOT.setAttribute('data-xlr-active-mode', state.mode);

    el.modeOptions.forEach(function (button) {
      var selected = button.getAttribute('data-xlr-mode') === state.mode;
      button.setAttribute('aria-checked', selected ? 'true' : 'false');
    });
    el.choiceCards.forEach(function (card) {
      card.classList.toggle('is-selected', card.getAttribute('data-xlr-card') === state.mode);
    });

    el.qualTiles.forEach(function (tile) {
      var selected = Number(tile.getAttribute('data-xlr-qual')) === state.qty;
      tile.classList.toggle('is-selected', selected);
      tile.setAttribute('aria-checked', selected ? 'true' : 'false');
    });
    if (el.qualSub2) {
      setText(el.qualSub2, el.qualSub2.getAttribute(state.mode === 'sub' ? 'data-sub-copy' : 'data-one-copy') || '');
    }
    if (el.qualNote && el.qualNoteText) {
      setText(el.qualNoteText, el.qualNote.getAttribute('data-note-' + state.qty) || '');
    }

    var packs = state.qty + ' pack' + (state.qty > 1 ? 's' : '');
    setText(el.subBadge, 'MOST POPULAR · SAVE ' + (state.qty === 2 ? '20%' : '15%'));
    setText(el.subCadence, packs + ' (' + state.qty * 5 + ' tablets) · delivered every 30 days');
    setText(el.subPrice, money(PRICES.sub[state.qty]));
    setText(el.subWas, money(PRICES.retail[state.qty]));
    setText(el.subBilledRow, money(PRICES.sub[state.qty]) + ' every 30 days · ' + packs + ' per delivery');
    setText(el.onePrice, money(PRICES.one[state.qty]));
    if (el.oneWas) {
      el.oneWas.hidden = state.qty !== 2;
      el.oneWas.textContent = money(PRICES.retail[state.qty]);
    }

    if (state.mode === 'sub') {
      setText(el.billedNote, money(d.base) + ' today, then ' + money(d.base) + ' every 30 days · cancel anytime');
      setText(el.announce, 'MONTHLY REFILLS · SAVE ' + d.savingsPct + '% + FREE GIFTS');
      setText(el.stickyLabel, 'Save ' + d.savingsPct + '% + Free Gifts');
      setText(el.trust2, '✓ Free shipping');
      setText(el.trust3, '✓ Cancel anytime');
    } else {
      setText(el.billedNote, money(d.base) + ' today · ' + packs + ' (' + state.qty * 5 + ' tablets) · one-time, no subscription');
      setText(el.announce, 'BUY ONCE · FREE FOREVER BOTTLE');
      setText(el.stickyLabel, state.qty === 2 ? 'Save $4.95 + Free Bottle' : 'Free Forever Bottle');
      setText(el.trust2, '✓ Free bottle included');
      setText(el.trust3, '✓ No subscription');
    }

    setText(el.valueName, state.qty + '× X-ALL Tablet Pack' + (state.qty > 1 ? 's' : ''));
    setText(el.valueWas, money(d.retail));
    setText(el.valuePrice, money(d.base));
    setText(el.valueTotal, money(d.base));
    setText(el.valueFootnote, state.mode === 'sub'
      ? 'Subscribe & Save renews every 30 days. Skip, pause or cancel anytime.'
      : 'One-time purchase. Shipping calculated at checkout.');

    if (el.cartImg) el.cartImg.src = asset('pack1');
    var packsTight = state.qty + ' pack' + (state.qty > 1 ? 's' : '');
    setText(el.cartMode, state.mode === 'sub'
      ? 'Subscribe & Save · every 30 days · ' + packsTight
      : 'One-time purchase · ' + packsTight);
    setText(el.cartQty, String(state.qty));
    setText(el.cartPrice, money(d.base));
    if (el.cartDec) el.cartDec.disabled = state.qty === 1;
    if (el.cartInc) el.cartInc.disabled = state.qty === 2;

    if (el.clothCard) el.clothCard.classList.toggle('is-added', state.cloth);
    if (el.clothToggle) {
      el.clothToggle.classList.toggle('is-added', state.cloth);
      el.clothToggle.setAttribute('aria-pressed', state.cloth ? 'true' : 'false');
      el.clothToggle.textContent = state.cloth
        ? copyText('addon_added_label', 'Added ✓')
        : copyText('addon_add_label', 'Add to order');
    }
    setText(el.subtotal, money(d.total));
    setText(el.shippingNote, state.mode === 'sub' ? 'Subscription shipping is free' : 'Shipping calculated at checkout');

    if (el.drawerScrim) {
      el.drawerScrim.classList.toggle('is-open', state.cartOpen);
      el.drawerScrim.setAttribute('aria-hidden', state.cartOpen ? 'false' : 'true');
    }
    document.body.classList.toggle('xl-scroll-lock', state.cartOpen || state.demoOpen);

    renderGallery();
    renderTestimonials();
    renderDemo();
    return d;
  }

  function selectQty(value) {
    value = Number(value);
    if (value !== 1 && value !== 2) return;
    if (state.qty === value) return;
    state.qty = value;
    render();
    emit('lander_quantity_select', { mode: state.mode, packs: value, refills: value * 5 });
  }

  function selectMode(value) {
    if (value !== 'sub' && value !== 'one') return;
    if (state.mode === value) return;
    state.mode = value;
    render();
    emit('lander_mode_select', { mode: value, packs: state.qty });
  }

  function toggleCloth() {
    state.cloth = !state.cloth;
    render();
    emit('lander_addon_toggle', { addon: 'cleaning-cloths', added: state.cloth, mode: state.mode });
  }

  function setBackgroundInert(value) {
    var card = ROOT.querySelector('.xl-card');
    var sticky = ROOT.querySelector('.xl-sticky-bar');
    [card, sticky].forEach(function (node) {
      if (!node) return;
      if (value) node.setAttribute('inert', '');
      else node.removeAttribute('inert');
    });
  }

  function openCart() {
    drawerReturnFocus = document.activeElement;
    state.cartOpen = true;
    render();
    setBackgroundInert(true);
    window.setTimeout(function () { if (el.drawerClose) el.drawerClose.focus(); }, 0);
    emit('lander_drawer_open', { mode: state.mode, packs: state.qty });
  }

  function closeCart() {
    if (!state.cartOpen) return;
    state.cartOpen = false;
    render();
    setBackgroundInert(false);
    if (drawerReturnFocus && typeof drawerReturnFocus.focus === 'function') drawerReturnFocus.focus();
    drawerReturnFocus = null;
  }

  function trapDrawerFocus(event) {
    if (!state.cartOpen || event.key !== 'Tab' || !el.drawer) return;
    var focusable = Array.prototype.slice.call(el.drawer.querySelectorAll(
      'button:not([disabled]), a[href], input:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (node) { return node.offsetParent !== null; });
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault(); last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault(); first.focus();
    }
  }

  function toggleFaq(item) {
    var index = item.getAttribute('data-xl-faq');
    var open = !state.faqOpen[index];
    state.faqOpen[index] = open;
    var button = item.querySelector('[data-xl="faq-toggle"]');
    var panel = item.querySelector('[data-xl="faq-answer"]');
    var sign = item.querySelector('[data-xl="faq-sign"]');
    if (button) button.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (panel) panel.hidden = !open;
    if (sign) sign.textContent = open ? '–' : '+';
    if (open) emit('lander_faq_open', { index: Number(index) });
  }

  function promoteVideo(video) {
    if (!video || video.getAttribute('data-xl-promoted') === 'true') return;
    var source = video.querySelector('source[data-src]');
    if (source && source.getAttribute('data-src')) source.src = source.getAttribute('data-src');
    video.setAttribute('data-xl-promoted', 'true');
    try { video.load(); } catch (err) {}
    var promise = video.play();
    if (promise && promise.catch) promise.catch(function () {});
  }

  function applyGalleryMedia(img, video, key, still) {
    var videoUrl = VIDEO_KEYS[key] ? asset(VIDEO_KEYS[key]) : '';
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (video && videoUrl && !reduced) {
      if (video.getAttribute('data-xl-src') !== videoUrl) {
        video.src = videoUrl;
        video.setAttribute('data-xl-src', videoUrl);
      }
      video.hidden = false;
      if (img) img.hidden = true;
      var promise = video.play();
      if (promise && promise.catch) promise.catch(function () {});
    } else {
      if (video) { video.pause(); video.hidden = true; }
      if (img) { img.hidden = false; if (still) img.src = still; }
    }
  }

  function renderGallery() {
    var heroIndex = ((state.slide % HERO_KEYS.length) + HERO_KEYS.length) % HERO_KEYS.length;
    var heroKey = HERO_KEYS[heroIndex];
    applyGalleryMedia(el.heroImg, el.heroVideo, heroKey, asset(heroKey));
    el.dots.forEach(function (dot, index) { dot.classList.toggle('is-active', index === heroIndex); });

    var buyboxIndex = ((state.buyboxSlide % BUYBOX_KEYS.length) + BUYBOX_KEYS.length) % BUYBOX_KEYS.length;
    var buyboxKey = BUYBOX_KEYS[buyboxIndex];
    applyGalleryMedia(el.buyboxImg, el.buyboxVideo, buyboxKey, asset(buyboxKey));
    if (el.buyboxImg) el.buyboxImg.alt = BUYBOX_ALT[buyboxIndex];
    if (el.buyboxVideo) el.buyboxVideo.setAttribute('aria-label', BUYBOX_ALT[buyboxIndex]);
    el.thumbs.forEach(function (thumb, index) { thumb.classList.toggle('is-active', index === buyboxIndex); });
  }

  function renderTestimonials() {
    if (!el.testimonials.length) return;
    var index = ((state.testimonialSlide % el.testimonials.length) + el.testimonials.length) % el.testimonials.length;
    el.testimonials.forEach(function (slide, i) { slide.classList.toggle('is-active', i === index); });
    el.testimonialDots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === index); });
  }

  function renderCountdown() {
    var remaining = Math.max(0, countdownEnd - Date.now());
    var hours = String(Math.floor(remaining / 3600000)).padStart(2, '0');
    remaining %= 3600000;
    var minutes = String(Math.floor(remaining / 60000)).padStart(2, '0');
    remaining %= 60000;
    var seconds = String(Math.floor(remaining / 1000)).padStart(2, '0');
    setText(el.countdown, hours + ':' + minutes + ':' + seconds);
  }

  function renderDemo() {
    if (!el.modalScrim) return;
    el.modalScrim.classList.toggle('is-open', state.demoOpen);
    el.modalScrim.setAttribute('aria-hidden', state.demoOpen ? 'false' : 'true');
    if (!state.demoOpen) {
      if (el.modalVideo) el.modalVideo.pause();
      return;
    }
    setText(el.modalTitle, copyText('demo_cloths_title', 'Multi-Use Cleaning Cloths'));
    setText(el.modalDesc, copyText('demo_cloths_desc', 'Reusable cloths for wiping up cleaner without disposable paper towels.'));
    if (el.modalVideo) {
      var source = el.modalVideo.querySelector('source');
      if (source) source.setAttribute('data-src', asset('demoCloths'));
      promoteVideo(el.modalVideo);
    }
  }

  function openDemo() {
    state.demoOpen = true;
    render();
    if (el.modalClose) el.modalClose.focus();
    emit('lander_addon_demo_open', { addon: 'cleaning-cloths' });
  }

  function closeDemo() {
    state.demoOpen = false;
    render();
    if (el.clothCard) {
      var trigger = el.clothCard.querySelector('[data-xl="addon-demo"]');
      if (trigger) trigger.focus();
    }
  }

  function openWordVideo(trigger) {
    if (!trigger || !el.wordScrim || !el.wordVideo) return;
    wordReturnFocus = trigger;
    wordMarqueePaused = true;
    var source = el.wordVideo.querySelector('source');
    if (source) source.setAttribute('data-src', trigger.getAttribute('data-xl-word-src') || '');
    var poster = trigger.getAttribute('data-xl-word-poster');
    if (poster) el.wordVideo.poster = poster;
    promoteVideo(el.wordVideo);
    el.wordScrim.classList.add('is-open');
    el.wordScrim.setAttribute('aria-hidden', 'false');
    document.body.classList.add('xl-scroll-lock');
    if (el.wordClose) el.wordClose.focus();
    emit('lander_word_video_open');
  }

  function closeWordVideo() {
    wordMarqueePaused = false;
    if (!el.wordScrim) return;
    el.wordScrim.classList.remove('is-open');
    el.wordScrim.setAttribute('aria-hidden', 'true');
    if (el.wordVideo) el.wordVideo.pause();
    if (!state.cartOpen && !state.demoOpen) document.body.classList.remove('xl-scroll-lock');
    if (wordReturnFocus && wordReturnFocus.focus) wordReturnFocus.focus();
    wordReturnFocus = null;
  }

  function showCheckoutNotice(message) {
    if (!el.checkoutNotice) return;
    el.checkoutNotice.textContent = message;
    el.checkoutNotice.classList.add('is-visible');
  }

  function hideCheckoutNotice() {
    if (el.checkoutNotice) el.checkoutNotice.classList.remove('is-visible');
  }

  function setCheckoutBusy(active) {
    checkoutInFlight = active;
    document.body.classList.toggle('xl-checkout-leaving', active);
    if (!el.checkout) return;
    el.checkout.disabled = active;
    el.checkout.setAttribute('aria-busy', active ? 'true' : 'false');
    if (active) {
      if (!el.checkout.getAttribute('data-original-label')) el.checkout.setAttribute('data-original-label', el.checkout.textContent);
      el.checkout.textContent = copyText('checkout_loading_label', 'Redirecting to checkout…');
    } else {
      el.checkout.textContent = el.checkout.getAttribute('data-original-label') || copyText('checkout_button_label', 'Secure Checkout');
    }
  }

  function cartPayload() {
    var products = CONFIG.commerce.products;
    var bonus = CONFIG.commerce.bonus;
    var plans = CONFIG.commerce.plans.mpc || {};
    var mpc = products.mpc || {};
    var cloth = products.cloths || {};
    var plan = plans['30day'] && plans['30day'][state.qty - 1];
    if (!mpc.variantId) return { ok: false, reason: 'MPC variant is unavailable' };
    if (state.mode === 'sub' && !plan) return { ok: false, reason: '30-day subscription plan is unavailable' };
    if (!bonus.bottle || !bonus.bottle.variantId) return { ok: false, reason: 'Forever Bottle gift is unavailable' };
    if (state.mode === 'sub' && (!bonus.guide || !bonus.guide.variantId)) return { ok: false, reason: 'Cleaning Guide gift is unavailable' };
    if (state.cloth && !cloth.variantId) return { ok: false, reason: 'Cleaning Cloths add-on is unavailable' };

    var properties = {
      _xall_lander_offer: OFFER_ID,
      _xall_lander_uid: OFFER_UID,
      _xall_purchase_mode: state.mode,
      _xall_refill_packs: String(state.qty)
    };
    var base = { id: mpc.variantId, quantity: state.qty, properties: properties };
    if (state.mode === 'sub') base.selling_plan = plan;
    var items = [base, { id: bonus.bottle.variantId, quantity: 1, properties: { _xall_lander_gift: 'forever-bottle', _xall_lander_offer: OFFER_ID } }];
    if (state.mode === 'sub') {
      items.push({ id: bonus.guide.variantId, quantity: 1, properties: { _xall_lander_gift: 'cleaning-guide', _xall_lander_offer: OFFER_ID } });
    }
    if (state.cloth) {
      items.push({ id: cloth.variantId, quantity: 1, properties: { _xall_lander_addon: 'cleaning-cloths', _xall_lander_offer: OFFER_ID } });
    }
    return {
      ok: true,
      items: items,
      discountCode: state.mode === 'sub' ? FREE_SHIP_CODE : (state.qty === 2 ? TWO_PACK_CODE : ''),
      total: current().total
    };
  }

  function cartAttributes() {
    var attrs = getAttribution();
    attrs.offer_id = OFFER_ID;
    attrs.uid = OFFER_UID;
    attrs.landing_page = OFFER_ID;
    attrs.purchase_mode = state.mode;
    attrs.refill_packs = String(state.qty);
    attrs.cloth_addon = state.cloth ? 'yes' : 'no';
    return attrs;
  }

  function updateCartState(discountCode) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: cartAttributes(), discount: discountCode })
    }).then(function (response) {
      if (!response.ok) return response.json().then(function (body) { throw new Error(body.description || 'Cart update failed'); });
      return response.json();
    });
  }

  function verifyDiscount(expected) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (response) {
      if (!response.ok) throw new Error('Cart verification failed');
      return response.json();
    }).then(function (cart) {
      var codes = cart.discount_codes || [];
      if (!expected) {
        if (codes.length) throw new Error('Unexpected discount remains on cart');
        return cart;
      }
      var match = codes.filter(function (entry) { return String(entry.code).toUpperCase() === expected.toUpperCase(); })[0];
      if (!match) throw new Error('Expected discount is missing');
      if (match.applicable === false) throw new Error('Expected discount is not applicable');
      return cart;
    });
  }

  function goToCheckout() {
    if (checkoutInFlight) return;
    hideCheckoutNotice();
    var payload = cartPayload();
    if (!payload.ok) {
      console.warn('[xall-lander-refills] checkout blocked:', payload.reason);
      showCheckoutNotice(copyText('checkout_blocked_notice', 'This offer is not ready to check out yet. Please try again shortly.'));
      return;
    }
    setCheckoutBusy(true);
    fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart clear failed');
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: payload.items })
        });
      })
      .then(function (response) {
        if (!response.ok) return response.json().then(function (body) { throw new Error(body.description || 'Cart add failed'); });
        return updateCartState(payload.discountCode);
      })
      .then(function () { return verifyDiscount(payload.discountCode); })
      .then(function (cart) {
        emit('lander_checkout_click', {
          mode: state.mode,
          packs: state.qty,
          refills: state.qty * 5,
          cloth_added: state.cloth,
          item_count: cart.item_count,
          discount_code: payload.discountCode,
          total: payload.total
        });
        window.location = '/checkout';
      })
      .catch(function (err) {
        console.warn('[xall-lander-refills] checkout failed:', err);
        showCheckoutNotice(copyText('checkout_error_notice', 'Something went wrong building your order. Please try again.'));
        setCheckoutBusy(false);
      });
  }

  el.modeOptions.forEach(function (button) {
    button.addEventListener('click', function () { selectMode(button.getAttribute('data-xlr-mode')); });
  });
  el.qualTiles.forEach(function (tile) {
    tile.addEventListener('click', function () {
      var packs = Number(tile.getAttribute('data-xlr-qual'));
      if (packs === state.qty) return;
      selectQty(packs);
      emit('lander_qualifier_select', {
        answer: packs === 2 ? 'every-day' : 'few-times-a-week',
        packs: packs,
        mode: state.mode
      });
    });
  });
  el.choiceCards.forEach(function (card) {
    card.addEventListener('click', function (event) {
      if (event.target.closest('button')) return;
      selectMode(card.getAttribute('data-xlr-card'));
    });
  });
  [el.modeOptions, el.qualTiles].forEach(function (group) {
    group.forEach(function (button, index) {
      button.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft' && event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
        event.preventDefault();
        var forward = event.key === 'ArrowRight' || event.key === 'ArrowDown';
        var next = forward ? (index + 1) % group.length : (index - 1 + group.length) % group.length;
        group[next].click();
        group[next].focus();
      });
    });
  });
  if (el.startCta) el.startCta.addEventListener('click', openCart);
  if (el.drawerClose) el.drawerClose.addEventListener('click', closeCart);
  if (el.drawerScrim) el.drawerScrim.addEventListener('click', function (event) { if (event.target === el.drawerScrim) closeCart(); });
  if (el.cartDec) el.cartDec.addEventListener('click', function () { selectQty(1); });
  if (el.cartInc) el.cartInc.addEventListener('click', function () { selectQty(2); });
  if (el.clothToggle) el.clothToggle.addEventListener('click', toggleCloth);
  if (el.clothCard) {
    var demoButton = el.clothCard.querySelector('[data-xl="addon-demo"]');
    if (demoButton) demoButton.addEventListener('click', openDemo);
  }
  if (el.modalClose) el.modalClose.addEventListener('click', closeDemo);
  if (el.modalScrim) el.modalScrim.addEventListener('click', function (event) { if (event.target === el.modalScrim) closeDemo(); });
  if (el.checkout) el.checkout.addEventListener('click', goToCheckout);

  if (el.prev) el.prev.addEventListener('click', function () { state.slide -= 1; renderGallery(); });
  if (el.next) el.next.addEventListener('click', function () { state.slide += 1; renderGallery(); });
  el.dots.forEach(function (dot, index) { dot.addEventListener('click', function () { state.slide = index; renderGallery(); }); });
  el.thumbs.forEach(function (thumb, index) { thumb.addEventListener('click', function () { state.buyboxSlide = index; renderGallery(); }); });
  if (el.testimonialPrev) el.testimonialPrev.addEventListener('click', function () { state.testimonialSlide -= 1; renderTestimonials(); });
  if (el.testimonialNext) el.testimonialNext.addEventListener('click', function () { state.testimonialSlide += 1; renderTestimonials(); });
  el.testimonialDots.forEach(function (dot, index) { dot.addEventListener('click', function () { state.testimonialSlide = index; renderTestimonials(); }); });
  el.faqItems.forEach(function (item) {
    var button = item.querySelector('[data-xl="faq-toggle"]');
    if (button) button.addEventListener('click', function () { toggleFaq(item); });
  });

  ROOT.addEventListener('click', function (event) {
    var anchor = event.target.closest('a[href^="#"]');
    if (!anchor) return;
    var target = document.getElementById(anchor.getAttribute('href').slice(1));
    if (!target) return;
    event.preventDefault();
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
  });
  var wordStrip = ROOT.querySelector('.xl-word-strip');
  if (wordStrip) wordStrip.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-xl="word-video-open"]');
    if (trigger) openWordVideo(trigger);
  });

  (function initWordMarquee() {
    var strip = wordStrip;
    if (!strip || strip.children.length < 2) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    strip.style.scrollSnapType = 'none';
    strip.setAttribute('data-xl-marquee', 'true');

    Array.prototype.slice.call(strip.children).forEach(function (item) {
      var clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      Array.prototype.forEach.call(clone.querySelectorAll('button, a'), function (node) {
        node.setAttribute('tabindex', '-1');
      });
      Array.prototype.forEach.call(clone.querySelectorAll('video[data-xl="lazy-video"]'), function (video) {
        var original = item.querySelector('video[data-xl="lazy-video"]');
        video.removeAttribute('data-xl');
        var source = original && original.querySelector('source');
        var src = original ? (original.currentSrc || (source && (source.src || source.getAttribute('data-src')))) : '';
        if (src) {
          video.innerHTML = '';
          video.src = src;
          video.muted = true;
          var promise = video.play && video.play();
          if (promise && promise.catch) promise.catch(function () {});
        }
      });
      strip.appendChild(clone);
    });

    var visible = true;
    var position = strip.scrollLeft;
    var last = 0;
    var speed = 32;
    var idleTimer = null;

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0] ? entries[0].isIntersecting : true;
      }, { rootMargin: '100px' }).observe(strip);
    }

    function pause() { wordMarqueePaused = true; }
    function resumeSoon(delay) {
      clearTimeout(idleTimer);
      idleTimer = setTimeout(function () {
        wordMarqueePaused = false;
        position = strip.scrollLeft;
      }, delay || 2000);
    }

    strip.addEventListener('pointerenter', pause);
    strip.addEventListener('pointerleave', function () { resumeSoon(400); });
    strip.addEventListener('touchstart', pause, { passive: true });
    strip.addEventListener('touchend', function () { resumeSoon(2500); }, { passive: true });
    strip.addEventListener('focusin', pause);
    strip.addEventListener('focusout', function () { resumeSoon(400); });

    function step(timestamp) {
      if (!last) last = timestamp;
      var delta = Math.min(64, timestamp - last);
      last = timestamp;
      if (!wordMarqueePaused && visible && !document.hidden) {
        if (Math.abs(strip.scrollLeft - position) > 2) position = strip.scrollLeft;
        position += speed * delta / 1000;
        var half = strip.scrollWidth / 2;
        if (half > 0 && position >= half) position -= half;
        strip.scrollLeft = position;
      }
      window.requestAnimationFrame(step);
    }
    window.requestAnimationFrame(step);
  })();
  if (el.wordClose) el.wordClose.addEventListener('click', closeWordVideo);
  if (el.wordScrim) el.wordScrim.addEventListener('click', function (event) { if (event.target === el.wordScrim) closeWordVideo(); });

  document.addEventListener('keydown', function (event) {
    trapDrawerFocus(event);
    if (event.key !== 'Escape') return;
    if (el.wordScrim && el.wordScrim.classList.contains('is-open')) closeWordVideo();
    else if (state.demoOpen) closeDemo();
    else if (state.cartOpen) closeCart();
  });

  if (el.lazyVideos.length) {
    if ('IntersectionObserver' in window) {
      var videoObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          promoteVideo(entry.target);
          videoObserver.unobserve(entry.target);
        });
      }, { rootMargin: '200px' });
      el.lazyVideos.forEach(function (video) { videoObserver.observe(video); });
    } else {
      el.lazyVideos.forEach(promoteVideo);
    }
  }

  (function initSticky() {
    var bar = ROOT.querySelector('.xl-sticky-bar');
    var hero = ROOT.querySelector('.xl-hero');
    var buybox = document.getElementById('offer-c');
    if (!bar || !hero || !buybox) return;
    var buyboxVisible = false;
    function update() {
      var pastHero = window.scrollY > hero.offsetTop + hero.offsetHeight;
      bar.classList.toggle('is-shown', pastHero && !buyboxVisible);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        buyboxVisible = entries[0] ? entries[0].isIntersecting : false;
        update();
      }).observe(buybox);
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  })();

  (function initScrollReveal() {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.documentElement.classList.add('xl-anim');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.remove('xl-reveal-pending');
        entry.target.classList.add('xl-revealed');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    ROOT.querySelectorAll('.xl-section, .xl-guarantee, .xl-final-cta, .xl-hero__proof-row').forEach(function (node) {
      var rect = node.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) return;
      node.classList.add('xl-reveal-pending');
      observer.observe(node);
    });
  })();

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    setCheckoutBusy(false);
    state.cartOpen = false;
    setBackgroundInert(false);
    document.body.classList.remove('xl-scroll-lock', 'xl-checkout-leaving');
    render();
  });

  captureAttribution();
  render();
  renderCountdown();
  window.setInterval(renderCountdown, 1000);
  // The shared paid-offer controller emits the single canonical lander_view
  // after its live offer state and attribution are initialized.

  window.XallLanderRefills = {
    state: state,
    config: CONFIG,
    current: current,
    render: render,
    selectMode: selectMode,
    selectQty: selectQty,
    toggleCloth: toggleCloth,
    openCart: openCart,
    closeCart: closeCart,
    goToCheckout: goToCheckout,
    getAttribution: getAttribution
  };
})();
